export default function SettingsController(
  $q,
  loaderService,
  ssDialogService,
  vmSharedModelService,
  vmSettingsDialog
) {
  const vm = this;

  vm.handleShowSettingsDialog = _handleShowSettingsDialog;
  vm.settings = null;

  function _handleShowSettingsDialog($event) {
    loaderService.showViewLoader = true;
    vmSharedModelService.getSettings(true)
      .then((settings) => {
        vm.settings = settings;
        loaderService.showViewLoader = false;
        showSettingsDialog($event, { settings: vm.settings });
      });
  }

  function showSettingsDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.settingsDialog = ssDialogService.alert(
      vmSettingsDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.settingsDialog);
  }
}

SettingsController.$inject = [
  '$q',
  'loaderService',
  'ssDialogService',
  'vmSharedModelService',
  'vmSettingsDialog',
];
